// Top swiper. Requires Swiper to be loaded (from CDN or bundled).
// Targets .top-swiper, with .swiper-pagination / .swiper-button-next / .swiper-button-prev.
export function initTopSwiper() {
  const el = document.querySelector('.top-swiper');
  if (!el || typeof Swiper === 'undefined') return;
  return new Swiper('.top-swiper', {
    speed: 1000,
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: { delay: 4000, disableOnInteraction: false },
    pagination: { el: '.swiper-pagination', type: 'bullets', clickable: true },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
  });
}
